import { JsonValue } from "../common/types";

import {
  CollaboratorNotification,
  CollaboratorTaskUpdateBodyInput,
  VocalUpdateBodyInput,
} from "./types";

export const collaboratorNotificationWriter = (data: CollaboratorNotification): JsonValue => ({
  uuid: data.uuid,
  occurredAt: data.occurredAt.toISO(),
  data: data.data,
  relatedEntityId: data.relatedEntityId,
  relatedEntityType: data.relatedEntityType,
  notificationType: data.notificationType,
  createdAt: data.createdAt.toISO(),
  updatedAt: data.updatedAt.toISO(),
  isRead: data.isRead,
});

export const collaboratorTaskPutWriter = (data: CollaboratorTaskUpdateBodyInput): JsonValue => ({
  status: data.status,
});

export const vocalUpdateWriter = (data: VocalUpdateBodyInput): JsonValue => ({
  noteText: data.noteText,
});
